import React from "react";
import { observer } from "mobx-react";
import { ReportViewStore } from "../../store";
import { ReportViewForm } from "./ReportViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type ReportViewProps = {
  reportViewStore: ReportViewStore;
};

export const ReportView: React.FC<ReportViewProps> = observer(
  ({ reportViewStore }) => {
    return (
      <div>
        <ReportViewForm
          name={reportViewStore.nameValue}
          reportTypeValue={reportViewStore.reportTypeValue}
          template={reportViewStore.templateValue}
          constants={reportViewStore.constantsValue}
          description={reportViewStore.descriptionValue}
          onPrint={(handlePrint: () => void) =>
            reportViewStore.printReport(handlePrint)
          }
          onCancel={() => reportViewStore.cancelReport()}
          onEdit={
            reportViewStore.isEditEnabled
              ? () => reportViewStore.editReport()
              : undefined
          }
        />
        <ErrorDialog
          open={reportViewStore.errorDialogOpened}
          title={reportViewStore.errorTitle}
          description={reportViewStore.errorDescription}
          onClose={() => reportViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
